import classNames from 'classnames';
import { ComponentDisplayType, GetPageComponentViewModel } from '@/types/cml-api';
import BannerTileItem from './banner-tile-item';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../../type';
import CustomAnimatedTitle from '../goodbye-summer-landing/custom-animated-title';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
  isGoodbyeSummerLanding?: boolean;
}
export function BannerTile({
  data,
  isLazy,
  isGoodbyeSummerLanding
}: Props) {
  const isBannerTileWithText = data?.displayType === ComponentDisplayType.BannerTileWithText;
  const renderedItems = data?.items?.map((item, index) => <BannerTileItem key={item.id || item?.mobileImageUrl} isLazy={isLazy} index={index} sortKey={data?.sortKey} componentId={data?.id} {...item} isBannerTileWithText={isBannerTileWithText} />);
  return <div className={classNames('homepage-container', deviceTypeClassGenerator(data.deviceTypes || ''))} data-sentry-component="BannerTile" data-sentry-source-file="banner-tile.tsx">
            {isGoodbyeSummerLanding ? <CustomAnimatedTitle title={data?.title || ''} /> : data.showTitleAndSubtitle && <div className='mb-2 flex-1'>
                        <span className='text-body-14 font-bold lg:text-body-16'>{data.title}</span>
                        {data.subTitle && <p className='font-regular my-1 text-caption-12 text-text-darkGray lg:my-2 lg:text-body-14'>
                                {data.subTitle}
                            </p>}
                    </div>}
            <div className={classNames('grid grid-cols-2 md:grid-cols-4', isBannerTileWithText ? 'gap-0 divide-x divide-y divide-x-reverse overflow-hidden rounded-md border lg:divide-y-0 [&>*:nth-child(2)]:!border-t-0 [&>*:nth-child(3)]:border-r-white lg:[&>*:nth-child(3)]:border-r-border-gray-light' : 'gap-4 md:gap-6')}>
                {renderedItems}
            </div>
        </div>;
}